var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"warper clearfix footLogoBox"},[_vm._v(" ©2014-"+_vm._s(new Date().getFullYear())),_c('a',{attrs:{"href":"Https://www.ruijienetworks.com/","target":"_blank"}},[_vm._v(" Ruijie Networks Co.,Ltd")])])
}
var staticRenderFns = []

export { render, staticRenderFns }